export default __webpack_public_path__ + "media/FoundersHub.9c516a66.svg";